(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeMedicalHistoryComponent', psychIntakeMedicalHistoryComponent);

    psychIntakeMedicalHistoryComponent.$inject = [];

    function psychIntakeMedicalHistoryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeMedicalHistoryController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/medical-history.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeMedicalHistoryController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeMedicalHistoryController($scope, $stateParams, $element) {
        var vm = this;
        
        function init() {
        }

        init();
    }
})();
